import LoginForm from 'components/auth/login/login-form'
import LogoHeader from 'components/auth/logo-header'
import SSOForm from 'components/auth/sso-form'
import { ArrowIcon, KeyIcon } from 'components/icons'
import Layout from 'components/layout/layout'
import Lines from 'components/layout/lines'
import { useApp } from 'context/app-context'
import Head from 'next/head'
import { useMemo } from 'react'
import type NextPageWithLayout from 'types/next-page-with-layout'

const Login: NextPageWithLayout = () => {
  const { setLastAuthProvider, authProvider } = useApp()
  const showSSOForm = useMemo(() => {
    return authProvider === 'sso'
  }, [authProvider])

  return (
    <div className="min-w-screen flex min-h-screen flex-col dark:bg-gray-700">
      <Head key="login">
        <title>{!showSSOForm ? `Login` : `Sign-in with SSO`} - Toolpath</title>
      </Head>
      <div className="h-full w-full flex-1 pb-10 pt-0 text-center md:pt-24">
        <div className="mx-auto w-full p-4 md:w-120">
          <LogoHeader />
          {!showSSOForm && <LoginForm />}
          {showSSOForm && <SSOForm verb="in" />}
          <div className="w-full pt-5 text-center text-sm">
            <button
              type="button"
              onClick={() =>
                setLastAuthProvider(
                  authProvider === 'sso' ? 'credentials' : 'sso',
                )
              }
              className="mx-auto flex items-center gap-1 text-gray-300 transition-all duration-300 hover:text-gray-400">
              {!showSSOForm && (
                <>
                  <KeyIcon className="mt-0.5 size-5 rotate-45" /> Sign-in with
                  SSO
                </>
              )}
              {showSSOForm && (
                <>
                  <ArrowIcon className="mt-0.5 size-4 -rotate-90" /> Log in with
                  password
                </>
              )}
            </button>
          </div>
        </div>
      </div>
      <Lines className="flex-0 mx-auto w-32" />
    </div>
  )
}

Login.getLayout = (page) => (
  <Layout hideNavigation={true} {...page.props}>
    {page}
  </Layout>
)

export default Login
